module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"/runner/_work/instore-core/instore-core/packages/gatsby-theme-instore-core/src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"85c059b4e6ad35e0c1bf5e5130a1e6e2"},
    },{
      plugin: require('../../gatsby-theme-instore-core/gatsby-browser.js'),
      options: {"plugins":[],"tenant":"instore","federationServerUrl":"http://localhost:5414","pathPrefix":"/","devExtensionsMode":true,"includeOffline":false},
    }]
